namespace TabAurous.OMS {
    export namespace CategoryMasterService {
        export const baseUrl = 'OMS/CategoryMaster';

        export declare function Create(request: Serenity.SaveRequest<CategoryMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<CategoryMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<CategoryMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<CategoryMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function AllCategoriesList(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<CategoryMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/CategoryMaster/Create",
            Update = "OMS/CategoryMaster/Update",
            Delete = "OMS/CategoryMaster/Delete",
            Retrieve = "OMS/CategoryMaster/Retrieve",
            List = "OMS/CategoryMaster/List",
            AllCategoriesList = "OMS/CategoryMaster/AllCategoriesList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'AllCategoriesList'
        ].forEach(x => {
            (<any>CategoryMasterService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
